import { render } from "./UserProfileComponent.vue?vue&type=template&id=1a0fe6f4&scoped=true"
import script from "./UserProfileComponent.vue?vue&type=script&lang=js"
export * from "./UserProfileComponent.vue?vue&type=script&lang=js"

import "./UserProfileComponent.vue?vue&type=style&index=0&id=1a0fe6f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0fe6f4"]])

export default __exports__